import { Nullable } from '@internal-libraries/kheops-ui-lib'
import { Patient } from '../../../dPpatients/vue/Classes/Patient'
import { StayType } from '../Type/StayType'
import { StayDto } from '../Type/StayDto'
import Affectation from '../../../dPhospi/vue/Classes/ClvrAffectation'
import AdmissionType from './ClvrAdmissionType'

export default class Stay {
    public refPatient: Nullable<Patient> = null

    public id: Nullable<number> = null
    public patientId: Nullable<number> = null
    public praticienId: Nullable<number> = null
    public groupId: Nullable<number> = null
    public serviceId: Nullable<number> = null
    public admissionTypeId?: number

    public type?: string
    public entreePreparee?: string
    public entreeModifiee?: string
    public entreePrevue = ''
    public sortiePrevue = ''
    public entreeReelle?: string
    public sortieReelle?: string
    public entree?: string
    public sortie?: string
    public isolationType?: string
    public currentAffectation?: Affectation
    public admissionType?: AdmissionType

    public constructor(data?: StayType) {
        if (data) {
            Object.assign(this, data)
        }
    }

    public toDto(): StayDto {
        return {
            id: this.id,
            patient_id: this.patientId,
            praticien_id: this.praticienId,
            group_id: this.groupId,
            service_id: this.serviceId,
            admission_type_id: this.admissionTypeId,
            type: this.type,
            entree_preparee: this.entreePreparee,
            entree_modifiee: this.entreeModifiee,
            entree_prevue: this.entreePrevue,
            sortie_prevue: this.sortiePrevue,
            entree_reelle: this.entreeReelle,
            sortie_reelle: this.sortieReelle,
            entree: this.entree,
            sortie: this.sortie,
            type_isolement: this.isolationType,
            _ref_curr_affectation: this.currentAffectation?.toDto(),
            _admission_type: this.admissionType?.toDto(),
        }
    }
}
